import { Component, OnInit } from '@angular/core';
import { FloatPopupService } from 'app/services/float-popup.service';
import { A3iWizardComponent } from '../a3i-wizard.component';
import { ActivityService } from 'app/services/activity.service';

@Component({
  selector: 'app-a3i-wizard-icon',
  templateUrl: './a3i-wizard-icon.component.html',
  styleUrls: ['./a3i-wizard-icon.component.css']
})
export class A3iWizardIconComponent implements OnInit {

	constructor(
		private activityService: ActivityService,
		private floatPopupService: FloatPopupService
	) { }

	openA3I() {
		const selection = this.activityService.selectedRecordsBS.getValue();
			if (selection && selection.ids && selection.ids.length) {
				this.activityService.selectedRecordsBS.next({
					ids: []
				});
			}
		this.floatPopupService.openPopup(A3iWizardComponent);
	}
	ngOnInit() {
	}

}
